import React from "react";
import { POST } from "../services/api";
import Sidebar from "./Sidebar";
import { MasterChapterProvider } from "../context/MasterChapter";

/**
 * Owns the whole admin chrome: the 256px fixed rail, the 64px fixed header and
 * the content well. Pages render plain content — they must not re-apply the
 * sidebar/header offsets or their own page background.
 */
const AdminLayout = ({ children }) => {

  const handleLogout = async () => {
    try { 
      await POST("/auth/admin-logout", {});
    } catch (error) {
      console.error("Logout API error:", error);
    } finally { 
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      localStorage.clear();

      window.location.href = "/admin";
    }       
  };

  return (
    <MasterChapterProvider>
      <div className="min-h-screen bg-slate-100 font-sans">
        <Sidebar handleLogout={handleLogout} />
        <main className="lg:pl-64 pt-16">
          <div className="mx-auto w-full max-w-content px-4 py-5 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </MasterChapterProvider>
  );
};

export default AdminLayout;
